import React, { forwardRef, useCallback } from 'react'
import { ErrorBoundary } from './ReactErrorBoundary'
import ErrorFallback from './Error'

import format from 'date-fns/format'

const formatDate = (formatString, date = new Date()) => format(date, formatString)

function modifyLogCall (logFunc, clientOrServer, args) {
  console[logFunc].apply(console, [clientOrServer].concat(Array.prototype.slice.call(args)))
}

function getClientLogger (logFunc) {
  return function () {
    modifyLogCall(logFunc, 'Client:', arguments)
  }
}

function getServerLogger (logFunc) {
  // const env = process.env.LOGGER_ENPOINT_ENV || 'unset';
  // if (process.env.NODE_ENV === 'test') {
  //   return () => null;
  // }
  // needs to be function rather than fat arrow or else `arguments` get lost
  return function () {
    const timestamp = formatDate('dd/MMM/yyyy:HH:mm:ss')
    const loggingPrefix = `[${timestamp}] `
    modifyLogCall(logFunc, loggingPrefix, arguments)
  }
}

const logError = getClientLogger('error')
const logToServer = getServerLogger('error')

const logErrorAndLogToServer = error => {
  logError(error)
  logToServer(error)
}

const WithErrorBoundary = ({ boundaryTag, children }) => {
  // useCallback w/ react-hooks so we don't pass a brand new function every time this re-renders
  // const FallbackComponent = useCallback(() =>
  //   <div style={{ display: 'none' }} data-component-boundary-error={`Error while rendering the component ${boundaryTag ? `([${boundaryTag}])` : ''}`} />
  //   , [boundaryTag]);
  const onError = useCallback((error) => {
    const errorMessage = `An error has occurred while rendering component contained with WithErrorBoundary: ${error.toString()}`
    console.log('WithErrorBoundary', error)
    logErrorAndLogToServer(`${boundaryTag ? `[${boundaryTag}]: ` : ''}${errorMessage}`)
  }, [boundaryTag])

  return <ErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>{children}</ErrorBoundary>
}

export const logActionErrorToServer = (boundaryTag, handlerName = '', error) => {
  const errorMessage = error.toString()
  const template = `[${boundaryTag}] [${handlerName}] ${errorMessage}`
  logErrorAndLogToServer(template)
}

export const withErrorBoundary = (boundaryTag, Component) => {
  const WrappedComponent = forwardRef((props, ref) =>
    <WithErrorBoundary boundaryTag={boundaryTag}><Component ref={ref} {...props} /></WithErrorBoundary>
  )
  WrappedComponent.displayName = `${getDisplayName(Component)}ErrorBoundary`
  return WrappedComponent
}
// helper for HOC
function getDisplayName (WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default WithErrorBoundary
